import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NumberField from 'components/forms/new/formikFormFields/NumberField';

const UnitPriceField = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.unitPrice && touched.unitPrice}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Unit Price <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter the unit price for this invoice line.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '110%',
                            alignItems: 'flex-start',
                            paddingTop: '8px',
                        }}>
                        <VStack width="110%" alignItems="normal">
                            <Field
                                component={NumberField}
                                id="unitPrice"
                                name="unitPrice"
                                validate={(value) =>
                                    (value == null || value === '') &&
                                    'Unit price is required'
                                }
                                darkMode={darkMode}
                            />
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the unit price for this invoice line"
                        ariaLabel="unit-price-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UnitPriceField;
